window.RechargeExtensions = {};
window.RechargeExtensions = {
  product_carousel_collection_ids: ["156258"],
};

/* Legacy Recharge (pre-Affinity 2.0) customer-portal patches — disabled ahead of the
   Affinity 2.0 migration (they target the old portal's DOM/window.ReCharge and no longer
   apply). Kept commented for reference; the RechargeExtensions config above stays active.
   Remove once Affinity 2.0 is confirmed live.

const subscriptionProductNames = [
  "Marine Collagen",
  "Marine Collagen Subscription 3 bottles every 60 days",
  "Marine Collagen Subscription 3 for 2 bottles every 2 months",
  "Marine Collagen Subscription 1 bottle every 20 days",
  "Marine Collagen Subscription 5 bottles every 100 days",
  "Marine Collagen Subscription 3 bottles delivered every 60 days",
  "Marine Collagen Subscription 3 Bottle delivered every 60 days.",
  "Marine Collagen Subscription 3 bottles delivered every 60 days",
  "Marine Collagen Subscription 3 bottles delivered every 60 days",
  "Marine Collagen Subscription 5 Bottles delivered every 100 days",
  "1 Bottle Liquid Collagen Subscription",
  "3 Bottles Liquid Collagen Subscription",
  "5 Bottles Liquid Collagen Subscription",
  "Marine Collagen Original Formula Ongoing Subscription",
  "2 Bottles Liquid Collagen Subscription",
  "3 Bottles Liquid Collagen Subscription",
  "5 Bottles Liquid Collagen Subscription ongoing",
  "1 Bottle Liquid Collagen MSM Ongoing Subscription",
  "2 Bottle Liquid Collagen MSM Ongoing Subscription",
  "3 Bottle Liquid Collagen MSM Ongoing Subscription",
  "5 Bottle Liquid Collagen MSM Ongoing Subscription",
  "20 Day Trial Bottle MSM",
  "5 Bottles Liquid Collagen Ongoing Subscription",
  "3 Bottles Liquid Collagen Ongoing Subscription",
  "3 for 2 Bottles Liquid Collagen Ongoing Subscription Buy Now",
  "5 for 4 Bottles Liquid Collagen Ongoing Subscription Buy Now",
  "3 for 2 Bottles Liquid Collagen Ongoing Subscription Buy Now DK",
  "Liquid Collagen Ongoing Subscription Bundle",
  "Liquid Collagen Ongoing Subscription - Irish",
  "Liquid Collagen Ongoing Subscription",
  "Liquid Collagen Ongoing Subscription",
  "Liquid Collagen Ongoing Subscription - Travel Bundle",
  "Premium Collagen SPF Bundle",
  "Marine Collagen Skincare Subscription Deal",
];

const subscriptionQuantityImageMap = {
  1: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_1b.png",
  2: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_2b.png",
  3: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_3b.png",
  4: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_4b.png",
  5: "https://cdn.shopify.com/s/files/1/0398/7547/7659/files/sp_5b.png",
};

function getTestGroup(key, percentage) {
  const forceTestGroup = new URLSearchParams(window.location.search).get(key);
  if (forceTestGroup) return forceTestGroup === "true" ? true : false;
  const storedTestGroup = localStorage.getItem(key);
  if (storedTestGroup) return storedTestGroup === "true";
  const testGroup = Math.random() < percentage ? true : false;
  localStorage.setItem(key, testGroup);
  return testGroup;
}

const emitObserver = new MutationObserver((entries) => {
  for (const entry of entries) {
    const { target } = entry;
    if (!target) return;

    changeProductName(target);

    hideSkipButtons(target);

    overrideCancelButton(target);
  }
});

function overrideCancelButton(target) {
  if (!target) return;
  const cancelUrl = window.location.href.includes("cancel");
  if (!cancelUrl) return;
  const forms = target.querySelectorAll("form");
  const currentSubscriptionId = getCurrentSubscriptionId();
  if (!currentSubscriptionId) return true;
  for (const form of forms) {
    if (
      !form.innerHTML
        .toLowerCase()
        .includes("please tell us why you're looking to cancel:")
    )
      continue;
    const anchor = document.createElement("a");
    anchor.href = `mailto:info@reverselife.co.uk?subject=Subscription Cancellation Request - ${currentSubscriptionId}`;
    anchor.target = "_blank";
    anchor.style.padding = "0";
    anchor.textContent = `To cancel your subscription please contact info@reverselife.co.uk with your cancellation request and include your subscription ID: ${currentSubscriptionId}.
      This may take up to 72 hours to process.`;
    form.replaceWith(anchor);
  }
}

function hideSkipButtons(target) {
  const skipButtons = target.querySelectorAll("button");
  if (!skipButtons) return;
  for (const skipButton of skipButtons) {
    if (!skipButton.textContent.includes("Skip")) continue;
    skipButton.style.display = "none";
  }
}

function changeProductName(target) {
  for (const subscriptionProductName of subscriptionProductNames) {
    const xPathResult = document.evaluate(
      `//*[text()='${subscriptionProductName}']`,
      target,
      null,
      XPathResult.FIRST_ORDERED_NODE_TYPE,
      null
    );
    if (!xPathResult.singleNodeValue) continue;

    const node = xPathResult.singleNodeValue.parentElement;
    if (!node) return;
    node.textContent = "Liquid Marine Collagen";
  }
}

emitObserver.observe(document.getElementsByTagName("body")[0], {
  childList: true,
  subtree: true,
});

function invokeImageObserver() {
  const subscriptions = getReChargeSubscriptions();
  if (!subscriptions) return;

  const subscriptionIds = getSubscriptionIds(subscriptions);
  const subscriptionImageMap = getSubscriptionImageMap(subscriptions);

  const subscriptionBottlesQuantities =
    getSubscriptionBottleQuantities(subscriptions);

  if (
    !subscriptionImageMap ||
    !subscriptionIds ||
    !subscriptionBottlesQuantities
  )
    return;
  const imageObserver = new MutationObserver((entries) => {
    for (const entry of entries) {
      const { target } = entry;
      if (!target) return;

      const targetImages = target.querySelectorAll("img");

      for (const targetImage of targetImages) {
        changeImage(
          targetImage,
          subscriptionIds,
          subscriptionImageMap,
          subscriptionBottlesQuantities
        );
      }
    }
  });

  imageObserver.observe(document.getElementsByTagName("body")[0], {
    attributes: true,
    subtree: true,
    childList: true,
    attributeFilter: ["src"],
  });
}

function changeImage(
  targetImage,
  subscriptionIds,
  subscriptionImageMap,
  subscriptionBottlesQuantities
) {
  if (targetImage.src.toLowerCase().includes("strawberry")) return;
  for (const subscriptionId of subscriptionIds) {
    const images = subscriptionImageMap[subscriptionId];
    if (!images || !images.length) continue;

    const image = images.find((imageItem) => {
      if (!imageItem) return false;
      if (typeof imageItem !== "string") return false;
      return targetImage.src === imageItem;
    });

    if (!image) continue;

    const quantity = subscriptionBottlesQuantities[subscriptionId];
    if (!quantity) continue;

    const quantityImage = subscriptionQuantityImageMap[quantity];
    if (!quantityImage) continue;

    targetImage.src = quantityImage;
  }
}

document.addEventListener("DOMContentLoaded", invokeImageObserver);

function getSubscriptionImageMap(subscriptions) {
  const subscriptionImageMap = subscriptions.reduce((acc, subscription) => {
    const images = subscription.product.images;
    if (!images || !images.length) return acc;

    acc[subscription.id] = images.flatMap((imageData) =>
      Object.values(imageData)
    );
    return acc;
  }, {});
  if (!Object.keys(subscriptionImageMap).length) return;

  return subscriptionImageMap;
}

function getSubscriptionBottleQuantities(subscriptions) {
  const subscriptionBottlesQuantities = subscriptions.reduce(
    (acc, subscription) => {
      let ongoing = subscription.properties.find(
        ({ name }) => name === "Ongoing"
      );
      if (!ongoing || !ongoing.value) {
        if (!subscription.sku) return acc;
        ongoing = { value: subscription.sku };
      }

      const quantity = ongoing.value[0];
      acc[subscription.id] = Number(quantity);
      return acc;
    },
    {}
  );
  if (!Object.keys(subscriptionBottlesQuantities).length) return;

  return subscriptionBottlesQuantities;
}

function getSubscriptionIds(subscriptions) {
  const subscriptionIds = subscriptions.map((subscription) => subscription.id);
  if (!subscriptionIds.length) return;

  return subscriptionIds;
}

function getReChargeSubscriptions() {
  if (!window.ReCharge) return;
  if (!window.ReCharge.subscriptions || !window.ReCharge.subscriptions.length)
    return;
  return window.ReCharge.subscriptions;
}

function getCurrentSubscriptionId() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("subscription");
}
*/
